

import { ChangeEvent, FC, forwardRef, useState } from 'react';

import { InputText } from '@eneco/sparky';
import { InputTextProps } from '@eneco/sparky/types';

interface Props {
  onChange: (value: string) => void;
}

const PostalCodeInput: FC<InputTextProps & Props> = forwardRef(
  ({ error, label, name, onChange, placeholder, value }, ref) => {
    const [viewValue, setViewValue] = useState('');

    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
      const matches = e.target.value.replace(/[^a-zA-Z\d\s]/g, '').match(/(\d{0,4})(\s?)([a-zA-Z]{0,2})/);
      if (!matches) return;

      const numbers = matches[1];
      const space = matches[2];
      const letters = matches[3].toUpperCase();
      const masked = numbers.length < 4 ? numbers : `${numbers}${space}${letters}`;
      const inputValue = masked.replace(' ', '');

      setViewValue(masked);
      onChange(inputValue);
    };

    return (
      <InputText
        error={error}
        label={label}
        name={name}
        ref={ref}
        onChange={onChangeHandler}
        placeholder={placeholder}
        value={viewValue || value || ''}
      />
    );
  },
);

export default PostalCodeInput;
